//Redux
import { useDispatch, useSelector } from "react-redux";
import { setComponentActive, setUserLogOut } from "../../reducers/userConfigSlice";
//Components
import { IoExitOutline } from "react-icons/io5";
import { MdOutlineDeliveryDining } from "react-icons/md";
import { FiShoppingBag } from "react-icons/fi";
//Styles
import "./style.css";
import { logOut } from "../../api/login";

export const MenuMobile = () => {
  const dispatch = useDispatch();
  const componentActive = useSelector((state) => state.aplicationConfig.userConfig.componentActive);

  const logOff = async () => {
    logOut();
    dispatch(setUserLogOut());
    localStorage.clear(); // Borra todo el localStorage
    sessionStorage.clear(); // Borra todo el sessionStorage
    dispatch(setComponentActive(""));
  };

  const handleMenu = (component) => {
    if (component === "logout") logOff();
    else {
      dispatch(setComponentActive(component));
      dispatch(setComponentActive("" + component));
    }
  };

  return (
    <nav className="bottom-toolbar" aria-label="Navegación de reparto">
      <button type="button" aria-label="Entregas asignadas" aria-current={componentActive === "delivery" ? "page" : undefined} onClick={() => handleMenu("delivery")}>
        <MdOutlineDeliveryDining aria-hidden="true" className={componentActive === "delivery" ? " optionMenuMobileActive " : ""} />
      </button>
      <button type="button" aria-label="Pedidos disponibles" aria-current={componentActive === "orders" ? "page" : undefined} onClick={() => handleMenu("orders")}>
        <FiShoppingBag aria-hidden="true" className={componentActive === "orders" ? " optionMenuMobileActive " : ""} />
      </button>
      <button type="button" aria-label="Cerrar sesión" onClick={() => handleMenu("logout")}>
        <IoExitOutline aria-hidden="true" size="1.7rem" />
      </button>
    </nav>
  );
};
